import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import {
  saveConditionDataNumber,
  saveConditionDataValue,
  saveConditionDescription,
  saveConditionStateDescription,
  saveConditionType,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectMezzoConditionState
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateCondition/MezzoConditions/SelectMezzoConditionState/SelectMezzoConditionState'
import SelectMezzoConditionStateIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateCondition/MezzoConditions/SelectMezzoConditionState/SelectMezzoConditionState'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectMezzoConditionStateIOS) : withStyles(SelectMezzoConditionState)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const { isEditConditionMode, isChangeConditionStateMode } = state.scenes.currentSceneCreating
  return {
    isMobile,
    path,
    isEditConditionMode,
    isChangeConditionStateMode,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveConditionDescription,
  saveConditionStateDescription,
  saveConditionType,
  saveConditionDataNumber,
  saveConditionDataValue,
}, dispatch)

enhance = withNotifications(enhance)
enhance = withAccessDenied(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectMezzoConditionStateEnhanced = enhance

export default withRouter(SelectMezzoConditionStateEnhanced)
